<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="100px" :rules="rules" ref="dialogForm">
      <el-form-item label="新密码" prop="password">
        <el-input v-model.trim="dialogForm.password" clearable show-password maxLength="14"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="repassword">
        <el-input v-model.trim="dialogForm.repassword" clearable show-password maxLength="14"></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,checkPwd} from '@utils/validate'
  export default {
    name: "ResetPwd",
    props: {dialogData: Object},
    data() {
      let checkRePass = (rule, value, callback) => {
        if (value !== this.dialogForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        dialogForm: {
          password: "",
          repassword: "",
        },
        rules: {
          password: [inputEmpty("新密码"), checkPwd()],
          repassword: [inputEmpty('确认新密码'), {validator: checkRePass, trigger: 'blur'}],
        },
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        this.$refs["dialogForm"].validate(isOk => {
          if (isOk) {
            this.openConfirm("重置该账号密码", async () => {
              let nv = {
                ...this.dialogForm,
                shop_id: row.shop.id,
                merchant_id: row.id
              };
              let res = await this.$Http.reviseShopAccount(nv);
              if (res) {
                this.msgSuccess("重置成功");
                this.dialogData.visible = false;
              }
            });
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
